import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { PRODUCTS_KEY, SINGLE_PRODUCT_KEY, SUBCATEGORIES_KEY,PRODUCT_GLOBAL_SEARCH_KEY } from "../constants/query.constants";
import {
  getProducts,
  getSingleProduct,
  fetchProductsGlobal
} from "../repositories/products/productRepository";

export const useInfiniteProductsQuery = (filters) => {
  return useInfiniteQuery({
    queryKey: [PRODUCTS_KEY, filters],
    queryFn: ({ pageParam = 1 }) =>
      getProducts({ ...filters, page: pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { current_page, last_page } = lastPage.products;
      return current_page < last_page ? current_page + 1 : undefined;
    },
    staleTime: 0,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
  });
};


export const useProductsQuery = (queryParams) => {
  return useQuery({
    queryKey: [PRODUCTS_KEY, queryParams],
    queryFn: () => getProducts(queryParams),
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 2,
  });
};


export const useSingleProductQuery = (productSlug) => {
  return useQuery({
    // ✅ Changed key so old cached product data is not used
    queryKey: [SINGLE_PRODUCT_KEY, productSlug, "related-products"],
    queryFn: () => getSingleProduct(productSlug),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: 2,
  });
};

export const useCategorySubcategories = (categorySlug) => {
  return useQuery({
    queryKey: [SUBCATEGORIES_KEY, categorySlug],
    queryFn: async () => {
      if (!categorySlug) return [];

      const res = await getProducts({ category: categorySlug, per_page: 200 });

      const products = res?.data || [];
      const uniqueSubs = [
        ...new Set(products.map((p) => p.subcategory).filter(Boolean)),
      ];

      return uniqueSubs;
    },
    enabled: !!categorySlug,
    staleTime: 1000 * 60 * 10,
  });
};

export const useProductGlobalSearch = (query) => {
  return useQuery({
    queryKey: [PRODUCT_GLOBAL_SEARCH_KEY,query],
    queryFn: () => fetchProductsGlobal(query),
    enabled : query.length>=2,
    staleTime : 1000 * 30,
  });
};


